/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { template } from 'lodash'
import { API_ADVANCED_ANNOTATIONS_URL, API_TEMPLATES_URL } from '../constants'
import { AdvancedAnnotation, Template } from '../types'

export const fetchTemplates = async (): Promise<Template[]> => {
    return fetch(`${API_TEMPLATES_URL}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async response => {
        return handleResponse(response)
    })
}

export const fetchActiveTemplates = async (dashboardId: number): Promise<Template[]> => {
    return fetch(`${API_TEMPLATES_URL}/active/${dashboardId}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async response => {
        return handleResponse(response)
    })
}

export const createTemplate = async (template: Template): Promise<Template> => {
    return fetch(`${API_TEMPLATES_URL}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(template)
    }).then(async response => {
        return handleResponse(response)
    })
}

export const getTemplate = async (templateId: string): Promise<Template> => {
    return fetch(`${API_TEMPLATES_URL}/${templateId}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async response => {
        return handleResponse(response)
    })
}

export const updateTemplate = async (template: Template): Promise<void> => {
    return fetch(`${API_TEMPLATES_URL}`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(template)
    }).then(async response => {
        return handleResponse(response)
    })
}

export const enableTemplate = async (templateId: string): Promise<void> => {
    return fetch(`${API_TEMPLATES_URL}/${templateId}/enable`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(template)
    }).then(async response => {
        return handleResponse(response)
    })
}

export const disableTemplate = async (templateId: string): Promise<void> => {
    return fetch(`${API_TEMPLATES_URL}/${templateId}/disable`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(template)
    }).then(async response => {
        return handleResponse(response)
    })
}

export const deleteTemplate = async (templateId?: string): Promise<void> => {
    return fetch(`${API_TEMPLATES_URL}/${templateId}`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async response => {
        return handleResponse(response)
    })
}

export const saveAnnotation = async (annotationData: AdvancedAnnotation): Promise<void> => {
    return fetch(API_ADVANCED_ANNOTATIONS_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(annotationData)
    }).then(async response => {
        return handleResponse(response)
    })
}

export const deleteAnnotation = async (id: string): Promise<void> => {
    return fetch(`${API_ADVANCED_ANNOTATIONS_URL}/${id}`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async response => {
        return handleResponse(response)
    })
}

export const getTemplateLimit = async (): Promise<{ templateLimit: number }> => {
    return fetch(`${API_TEMPLATES_URL}/config`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async response => {
        return handleResponse(response)
    })
}

const handleResponse = async (response: Response) => {
    let jsonData

    try {
        jsonData = await response.json()
    } catch {
        jsonData = null
    }

    if (!response.ok) {
        throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
    }

    return jsonData
}
